import * as React from 'react';

export function SvgLucidchart(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 6.00433V18.0043L10.5 24V21.0065L2.625 16.4989V7.50109L0 6.00433Z"
        fill="#F96B13"
      />
      <path
        d="M18.375 7.50109V19.5011L21 18.0043V6.00433L18.375 7.50109Z"
        fill="#CC4E00"
      />
      <path
        d="M7.875 1.49676L18.375 7.50108L21 6.00433L10.5 0L7.875 1.49676Z"
        fill="#FFCA73"
      />
      <path
        d="M0 6.00431L2.625 7.50107L5.25 6.00431L2.625 4.4989L0 6.00431Z"
        fill="#FFCA73"
      />
      <path
        d="M2.625 7.50109V16.4989L5.25 15.0021V6.00433L2.625 7.50109Z"
        fill="#CC4E00"
      />
      <path
        d="M10.5 21.0065V24L13.125 22.5033V19.5011L10.5 21.0065Z"
        fill="#CC4E00"
      />
      <path
        d="M2.625 16.4989L10.5 21.0065L13.125 19.5011L5.25 15.0021L2.625 16.4989Z"
        fill="#FFCA73"
      />
      <path
        d="M7.875 1.49673V4.49889L15.75 8.99785V18.0043L18.375 19.5011V7.50105L7.875 1.49673Z"
        fill="#F96B13"
      />
    </svg>
  );
}
